import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "../components/Navbar";
import ChatWidget from "../components/ChatWidget";
import Overview from "../tabs/Overview";
import Portfolio from "../tabs/Portfolio";
import Recommendations from "../tabs/Recommendations";
import Markets from "../tabs/Markets";
import IndianScreener from "../tabs/IndianScreener";
import GlobalMacro from "../tabs/GlobalMacro";
import Rebalancer from "../tabs/Rebalancer";
import Retirement from "../tabs/Retirement";
import Triggers from "../tabs/Triggers";
import AIBriefing from "../tabs/AIBriefing";
import { Toaster } from "sonner";

const MAP = {
  overview: Overview,
  portfolio: Portfolio,
  recommendations: Recommendations,
  markets: Markets,
  indian: IndianScreener,
  global: GlobalMacro,
  rebalancer: Rebalancer,
  retirement: Retirement,
  triggers: Triggers,
  ai: AIBriefing,
};

export default function Dashboard() {
  const [active, setActive] = useState(() => {
    const t = new URLSearchParams(window.location.search).get("tab");
    return MAP[t] ? t : "overview";
  });
  const Active = MAP[active];
  return (
    <div className="min-h-screen bg-[#080b11] flex flex-col">
      <Navbar active={active} setActive={setActive} />
      <main className="max-w-[1500px] w-full mx-auto px-4 lg:px-6 py-6 flex-1">
        <AnimatePresence mode="wait">
          <motion.div key={active}
            initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}>
            <Active />
          </motion.div>
        </AnimatePresence>
      </main>
      <footer data-noprint className="border-t border-[#1e293b] py-5">
        <div className="max-w-[1500px] mx-auto px-4 lg:px-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#64748b]">
          <span>© 2026 Alpha-Orchestrator · Personal quantitative investment research · Not investment advice</span>
          <span className="font-mono">Built by <span className="text-[#00e5ff]">Abhishek Singh</span></span>
        </div>
      </footer>
      <ChatWidget />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
